import React from 'react';
import { motion } from 'framer-motion';
import { MiniCountdown } from './CountdownUrgency';
export function Nav() {
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} className="fixed top-0 left-0 right-0 z-50" data-id="element-206">
      <div className="bg-gradient-to-r from-brand-pink-light via-brand-pink-mid/60 to-brand-pink-light border-b border-brand-pink-mid/40 shadow-sm" data-id="element-207">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-center" data-id="element-208">
          <MiniCountdown data-id="element-209" />
        </div>
      </div>
    </motion.nav>;
}